<template>
  <div>
    <h2>{{ $t("login.manage-company")  }}</h2>
    <div class="companies">
      <div v-for="tenant in tenants" :key="tenant.tenantId" class="company">
        <el-avatar :src="tenant.logo" :size="50"></el-avatar>
        <p class="mb-0">{{ tenant.name }}</p>
        <el-button class="button" @click="handleDelete(tenant.tenantId)" size="small">{{ $t("common.delete")  }}</el-button>
      </div>
    </div>
    <p>
      <router-link :to="{ name : 'LoginAsTenant' }">{{ $t("login.go-back-to-login-as-company")  }}</router-link>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tenants: [],
      tenantKey: "tenant",
    }
  },
  methods: {
    handleDelete(tenantId) {
      const tenants = this.tenants.filter(tenant => tenant.tenantId !== tenantId)
      localStorage.setItem(this.tenantKey, JSON.stringify(tenants));
      if (tenants.length === 0) {
        this.$router.push({ name: "LoginAsTenant"});
      }
    }
  },  
  beforeMount() {
    const tenants = JSON.parse(localStorage.getItem(this.tenantKey))
    this.tenants = tenants ?? [];
  }
}
</script>

<style scoped>

h2, 
.companies {
  margin-bottom: var(--column);
}
.companies {
  width: 100%;
}

.company {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: var(--column);
  width: 100%;
}

.button {
  margin-left: auto;
}

</style>